/* unplugin-vue-components disabled */import { render } from "./SpeachHtmlTranslationDialog.vue?vue&type=template&id=44df4042&scoped=true&ts=true"
import script from "./SpeachHtmlTranslationDialog.vue?vue&type=script&lang=ts"
export * from "./SpeachHtmlTranslationDialog.vue?vue&type=script&lang=ts"

import "./SpeachHtmlTranslationDialog.vue?vue&type=style&index=0&id=44df4042&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44df4042"]])

export default __exports__